import React from "react";
import { Image } from "semantic-ui-react";
import musitudeLogo from "../../assets/Musitude-Logo-white.png";

function IOSView() {
    return (
        <div
            className="app-landing row"
            style={{
                marginLeft: "auto",
                marginRight: "auto",
                textAlign: "center",
            }}
        >
            <div>
                <Image
                    src={musitudeLogo}
                    size="medium"
                    centered
                    style={{ paddingBottom: "60px" }}
                />

                <h3>
                    Musitude requires desktop or laptop using a physical qwerty
                    keyboard
                </h3>
            </div>
        </div>
    );
}

export default IOSView;
